<template>
  <div class="shortform-sign-up__other-way">
    <FormError :errors="view.validation.errors" field="social" />
    <GoogleSignInButton
      v-if="showGoogle"
      :authMode="authMode"
      :buttonLayout="googleButtonLayout"
      :view="view.googleAuthView"
    />
    <FacebookLoginButton
      v-if="showFacebook"
      :title="socialButtonTitle"
      :view="view.facebookAuthView"
    />
    <AppleSignInButton
      v-if="view.appleAuthView"
      :view="view.appleAuthView"
      :title="socialButtonTitle"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SocialAuthComponentView } from '@/models/auth/social'

import FormError from '@/components/ui/FormError.vue'
import GoogleSignInButton from './GoogleSignInButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import AppleSignInButton from './AppleSignInButton.vue'
import { AuthMode, type GoogleButtonLayout } from '@/models/auth/types'

const props = withDefaults(
  defineProps<{
    view: SocialAuthComponentView
    authMode: AuthMode
    googleButtonLayout?: GoogleButtonLayout
    showGoogle?: boolean
    showFacebook?: boolean
  }>(),
  {
    googleButtonLayout: 'default',
    showGoogle: true,
    showFacebook: true,
  },
)

// Keep the old public instance shape for unit-test page objects.
defineExpose({ socialView: props.view })

const socialButtonTitle = computed(() => {
  return props.authMode === AuthMode.Signin ? 'Sign in with' : 'Sign up with'
})
</script>
